if (!customElements.get('product-bar')) {
  class ProductBar extends HTMLElement {
    constructor() {
      super();
      this.priceElement = this.querySelector('.price'); // Assumons qu'un élément avec la classe .price existe
      this.updatePrice = this.updatePrice.bind(this);
      this.targetElementVisible = false;
      this.footerElementVisible = false;
    }

    connectedCallback() {
      this.targetElement = document.querySelector(
        `#${this.getAttribute('data-form-id')} [name="add"]`
      );
      this.footerElement = document.querySelector(
        '.shopify-section-group-footer-group .footer__links'
      );

      if (!this.targetElement) return;

      this.initObserver();
      document.addEventListener('price:change', this.updatePrice);

      const initialPriceElement = document.querySelector(
        '.price--on-sale .price-item--sale, .price__regular .price-item--regular'
      );
      if (initialPriceElement && this.priceElement) {
        this.priceElement.textContent = initialPriceElement.textContent;
      }
    }

    updatePrice(event) {
      console.log('updatePrice');
      if (event.detail && event.detail.price && this.priceElement) {
        // Préserver le prix barré (del) s'il existe
        const existingDel = this.priceElement.querySelector('del');
        if (existingDel) {
          // Remplacer seulement le prix principal, garder le prix barré
          const insElement = this.priceElement.querySelector('ins');
          if (insElement) {
            insElement.innerHTML = event.detail.price;
          } else {
            // Créer la structure avec ins et del
            this.priceElement.innerHTML = `<ins>${event.detail.price}</ins>${existingDel.outerHTML}`;
          }
        } else {
          // Pas de prix barré, remplacer normalement
          this.priceElement.innerHTML = event.detail.price;
        }
      }
    }

    updateVisibility() {
      // Si l'un des deux éléments est visible, on cache la barre (remove is-active)
      // Sinon on l'affiche (add is-active)
      if (this.targetElementVisible || this.footerElementVisible) {
        this.classList.remove('is-active');
      } else {
        this.classList.add('is-active');
      }
    }

    initObserver() {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.target === this.targetElement) {
              this.targetElementVisible = entry.isIntersecting;
            } else if (entry.target === this.footerElement) {
              this.footerElementVisible = entry.isIntersecting;
            }
          });
          this.updateVisibility();
        },
        {
          root: null,
          threshold: 0.1,
        }
      );

      this.observer.observe(this.targetElement);

      if (this.footerElement) {
        this.observer.observe(this.footerElement);
      }
    }

    disconnectedCallback() {
      if (!this.observer) return;

      if (this.targetElement) {
        this.observer.unobserve(this.targetElement);
      }

      if (this.footerElement) {
        this.observer.unobserve(this.footerElement);
      }

      document.removeEventListener('price:change', this.updatePrice);
    }
  }

  customElements.define('product-bar', ProductBar);
}
